import { useState } from "react";
import { PSV_REVIEW_NOTE_LIMIT } from "@api/shared-runtime/psv-review";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";

/** Reopening a decision carried forward from an earlier run asks for a reason,
 * which is saved as the item's note. Mount it only while reopening so the
 * draft starts empty each time. */
export function ReopenCarriedDecisionDialog({
  onReopen,
  onCancel,
}: {
  onReopen: (reason: string) => void;
  onCancel: () => void;
}) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();
  return (
    <AlertDialog
      open
      onOpenChange={(next) => {
        if (!next) {
          onCancel();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Why reopen this decision?</AlertDialogTitle>
          <AlertDialogDescription>
            This decision was carried forward from an earlier run. Reopening it
            moves the item back to pending, and later runs will stop carrying it
            forward.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Textarea
          aria-label="Reason for reopening"
          value={reason}
          maxLength={PSV_REVIEW_NOTE_LIMIT}
          rows={3}
          placeholder="Explain why this needs another look"
          onChange={(event) => setReason(event.target.value)}
        />
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={trimmed.length === 0}
            onClick={() => onReopen(trimmed)}
          >
            Reopen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
